<capra-toast class="progress-toast" type="processing">
	<h4 class="toast-header">Duplicating Report to your Personal content</h4>
	<p class="toast-text">Stay on this page to be notified when the Report is ready to use</p>
</capra-toast>
